<template>
	<div class="videosCourse ">
		<el-input v-model="key" class="h-[58px] text-[16px] mb-[10px]" @change="change"
			:placeholder="langInfo.study_keywords_search"></el-input>
		<div class="" v-if="isFinish&&subjectList.length>0">
			<div style="min-height: 500px;">
				<div :class="item.is_expired==1?'bg-[#e7e9eb]':'bg-[#F7F9FC]'" v-for="(item,index) in subjectList"
					:key="index" class="no-underline py-[20px] px-[16px] box-border   mb-[12px] ">
					<div class="rounded-[5px]   flex items-center justify-between">
						<div class="flex-1 flex">
							<el-image class="w-[147px] h-[112px] mr-[14px] rounded-[6px]"
								:src="item.courseSubject.image" fit="cover"></el-image>
							<div class="flex-1 ">
								<div class="text-[16px] text-[#000000]  mb-[10px] flex items-center justify-between">
									<div class="yw-text-cut-1 flex-1">
										{{item.courseSubject.name}}
									</div>
									<div @click="subjectInfoClick(item,index)"
										class="w-[200px] cursor-pointer text-right text-[#2979FF] text-[12px] ml-[20px]">
										{{langInfo.study_subject_view}}>>
									</div>
								</div>
								<div class="flex items-center mb-[8px] text-[12px]">
									<div class="flex items-center min-w-[90px] mr-[10px]">
										<img src="@/static/image/icon25.png" class="w-[15px] h-[15px] mr-[10px]" />
										<div class="flex-1  text-[#A2A2A2]">
											{{langInfo.study_subject_title}}
										</div>
									</div>
									<div class="flex-1  text-[#0F1419]">
										{{langInfo.study_total}}{{item.course_chapter_small_count}}{{langInfo.study_chapter}}：{{item.video_count}}{{langInfo.study_total_video}}
										|{{item.doc_count}}{{langInfo.study_course_video}}
									</div>
								</div>
								<div class="flex items-center mb-[8px] text-[12px]">
									<div class="flex items-center min-w-[90px] mr-[10px]">
										<img src="@/static/image/icon34.png" class="w-[15px] h-[15px] mr-[10px]" />
										<div class="  text-[#A2A2A2]">
											{{langInfo.study_teacher_title}}
										</div>
									</div>
									<div class="flex-1  text-[#0F1419]">
										{{item.teacher_info.name}} <label
											class=" text-[#2979FF] ml-[20px] cursor-pointer"
											@click="teacherInfoClick(item,index)">{{langInfo.study_teacher_view}}>></label>
									</div>
								</div>
								<div class="flex items-center mb-[10px] text-[12px]">
									<div class="flex items-center min-w-[90px] mr-[10px]">
										<img src="@/static/image/icon35.png" class="w-[15px] h-[15px] mr-[10px]" />
										<div class="  text-[#A2A2A2]">
											{{langInfo.study_exam_title}}
										</div>
									</div>
									<div class="flex-1  text-[#0F1419]">
										{{langInfo.study_exam_duration}}{{item.courseSubject.exam_duration}}min；{{langInfo.study_exam_total}}{{item.courseSubject.total_score}}；{{langInfo.study_exam_pass}}{{item.courseSubject.qualified_score_line}}
										<!-- <label class="cursor-pointer text-[#2979FF] ml-[20px]"
												@click="examInfoClick(item,index)">{{langInfo.exam_infor_details}}>></label> -->
									</div>
								</div>
								<div class="flex items-center mb-[8px] text-[12px] text-[#FF0000]">
									{{langInfo.validity_period}}:{{item.expiration_date}}
								</div>

								<div class="text-[#FF0000] text-[12px] mt-[5px]" v-if="item.is_expired==1">
									{{langInfo.study_subject_overdue}}
								</div>
								<div class="flex justify-between items-center">
									<div class="">

									</div>
									<div class="flex items-center">
										<div @click="officialClick(item,index)"
											:class="item.is_expired==1?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#bbbbbb] border-solid'"
											class=" mr-[10px] cursor-pointer  text-center px-[10px] box-border whitespace-nowrap h-[28px] leading-[28px] rounded-[4px]">
											{{langInfo.study_subject_sample}}
										</div>
										<div @click.stop="addStudyClick(item,index)"
											:class="item.is_expired==1?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#bbbbbb] border-solid'"
											class=" mr-[10px] cursor-pointer  text-center px-[10px] box-border whitespace-nowrap h-[28px] leading-[28px] rounded-[4px]">
											{{langInfo.study_subject_note}}
											<!-- 学习笔记  3，4 -->
										</div>
										<!-- <div v-if="item.is_subject_list==3" :class="item.isExpired?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#bbbbbb] border-solid'"
												class=" mr-[10px] cursor-pointer  text-center px-[10px] box-border whitespace-nowrap h-[28px] leading-[28px] rounded-[4px]">
												学习建议
											</div> -->
									</div>
								</div>
							</div>
						</div>
						<div class="flex items-center cursor-pointer text-[#FF0000] text-[14px]"
							@click="showClick(item,index)">
							<label v-if="item.isShow" class=" mr-[2px] cursor-pointer">点击收起</label>
							<label v-else-if="!item.isShow" class=" mr-[2px] cursor-pointer">点击展开</label>
							<img v-if="item.isShow" src="@/static/image/icon32.png"
								class="w-[24px] h-[24px] cursor-pointer" />
							<img v-else-if="!item.isShow" src="@/static/image/icon33.png"
								class="w-[24px] h-[24px] cursor-pointer" />
						</div>

					</div>

					<el-collapse v-if="item.isShow &&item.isFinish&&item.chapterList.length>0" v-model="item.activeName"
						accordion>
						<div class="" v-if="item.chapterList.length>0">
							<el-collapse-item :title="itm.chapter_name" :name="ind"
								v-for="(itm,ind) in item.chapterList" :key="ind">
								<div class="" v-if="itm.small_list_class.length>0">
									<div v-for="(smallItm,smallIndex) in itm.small_list_class" :key="smallIndex"
										class="py-[20px]  box-border section relative">
										<div class="flex justify-between ">
											<div class="flex-1">
												<div class="flex items-center">
													<img src="@/static/image/icon30.png"
														class="w-[16px] h-[16px]  mr-[6px]" alt="" srcset="" />
													<div class="text-[16px] text-[#101010] ">
														{{smallItm.chapter_name}}
													</div>
												</div>
												<div class="text-[12px] text-[#9399A5] ml-[22px] box-border">
													{{langInfo.study_video_duration}} {{smallItm.allTime}}
												</div>
											</div>
											<div class="flex justify-between">
												<div :class="item.is_expired==1?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#BBBBBB] border-solid'"
													@click="seeVideoClick(item,index,itm,ind,smallItm,smallIndex)"
													class="w-[80px] h-[30px] cursor-pointer mr-[10px] leading-[30px]    rounded-[4px]  text-center text-[14px]">
													{{langInfo.study_video_submit}}
												</div>
												<div :class="item.is_expired==1?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#BBBBBB] border-solid'"
													@click="viewRecord(item,index,itm,ind,smallItm,smallIndex)"
													class="w-[80px] h-[30px] cursor-pointer leading-[30px]    rounded-[4px]  text-center">
													{{langInfo.study_course_submit}}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="text-center" v-else-if="itm.small_list_class.length==0">
									{{langInfo.no_chapter_records}}
								</div>
							</el-collapse-item>
						</div>
					</el-collapse>
					<emptyPage v-else-if="item.isShow &&item.isFinish&&item.chapterList.length==0"
						:title="langInfo.no_chapter_records"></emptyPage>
				</div>
			</div>
			<div class="flex justify-center">
				<el-pagination :page-size="limit" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>


		<emptyPage v-else-if="isFinish&&subjectList.length==0" :title="langInfo.no_chapter_records"></emptyPage>

		<!-- 科目介绍 -->
		<el-dialog :title="langInfo.study_subject_title" :visible.sync="subjectVisible" :close-on-click-modal="false"
			width="50%" center>
			<div class="max-h-[50vh] overflow-y-scroll" v-html="subjectBlurb">
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="subjectVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="subjectVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 科目介绍 -->

		<!-- 讲师介绍 -->
		<el-dialog :title="langInfo.study_teacher_view" :visible.sync="teacherVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="" v-html="teacherInfo">

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="teacherVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="teacherVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 讲师介绍 -->
		<!-- 考试信息 -->
		<el-dialog :title="langInfo.exam_infor_details" :visible.sync="examVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="">
				<div class="mb-[6px]">
					{{langInfo.study_exam_duration}}:{{courseSubject.exam_duration}}min
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_total}}:{{courseSubject.total_score}}
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_pass}}:{{courseSubject.qualified_score_line}}
				</div>
				<div class="mb-[6px]" v-if="courseSubject.count">
					{{langInfo.questions_number}}:{{courseSubject.count}}
				</div>
				<div class="" v-if="courseSubject.score">
					{{langInfo.single_question_score}}:{{courseSubject.score}}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="examVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="examVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 考试信息 -->
		<!-- 视频 -->
		<playVideo :currentVideo="currentVideo" :videoVisible="videoVisible" :order_item_id="order_item_id"
			:selectChapterIndex="selectChapterIndex" @close="closeVideo" currentValue="getPlayValue">
		</playVideo>
		<!-- 视频 -->

		<!-- 官方样题 -->
		<el-dialog :title="langInfo.study_subject_sample" :visible.sync="officialVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="" v-html="officialInfo">

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="officialVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="officialVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 官方样题 -->
	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	import playVideo from '@/components/playVideo.vue'
	export default {
		name: "videosCourse",
		components: {
			playVideo,
			emptyPage
		},
		data() {
			return {
				// 科目
				key: '',
				// 科目
				page: 1,
				limit: 6,
				total: 0,
				isFinish: false,
				subjectList: [],
				subjectVisible: false, //科目介绍
				teacherVisible: false, //讲师介绍弹框
				examVisible: false, //考试信息
				courseSubject: {},


				videoVisible: false, //视频显示

				currentVideo: -1, //当前的章节
				order_item_id: -1,
				selectChapterIndex: -1,
				videoList: [],
				subjectBlurb: '',
				teacherInfo: "",
				langInfo: {},
				officialVisible: false,
				officialInfo: ''
			}
		},
		mounted() {

			this.getSubject()
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				document.title =this.langInfo.pc_name+'-'+ this.langInfo.study_my_vedio
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					document.title = this.langInfo.pc_name+'-'+this.langInfo.study_my_vedio
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			change(e) {
				console.log(e);
				this.key = e
				this.page = 1;
				this.total = 0
				this.isFinish = false

				this.getSubject()
			},
			currentChange(e) {
				this.page = e
				this.isFinish = false
				this.getSubject()
			},
			getSubject() {
				// is_subject_list=1题库2视频3课件笔记4全套
				this.$api.getMyPapersWithSubject({
					page: this.page,
					pageSize: this.limit,
					key: this.key,
					is_subject_list: '2,3,4'
				}).then((res) => {
					console.log(res);
					this.subjectList = res.data.data
					this.subjectList.forEach((item, index) => {
						this.$set(item, 'isShow', false)
						this.$set(item, 'isFinish', false)
						this.$set(item, 'activeName', 0)
						this.$set(item, 'chapterList', [])


					})

					this.total = res.data.total
					this.isFinish = true
				}).catch((error) => {
					console.log("error.code====" + error.code);
					this.isFinish = true
					if (error.code == 450) {
						setTimeout(() => {
							const currentUrl = this.$route.fullPath;
							localStorage.setItem('loginRedirect', currentUrl);
							this.$router.replace({ path: '/login' })
						}, 800)
					}
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			showClick(item, index) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}

				this.subjectList.forEach((itm, ind) => {
					if (index == ind) {
						itm.isShow = !itm.isShow
						if (itm.isShow) {
							this.order_item_id = itm.id
							itm.isFinish = false
							this.getChapterList(itm, index)
						}
					} else {
						itm.isShow = false
					}
				})
			},
			getChapterList(item, index) {
				var that = this
				this.$api.order_chapter_class({
					item_id: item.id,
				}).then((res) => {
					console.log("res.data========");
					console.log(res.data);

					res.data.forEach((item, index) => {
						item.small_list_class.forEach((itm, ind) => {
							let allTime = '00:00'
							if (itm.video_info) {
								allTime = that.convertSecondsToHMS(itm.video_info.file_size)
							}
							that.$set(itm, 'allTime', allTime)
						})
					})
					item.chapterList = res.data
					item.isFinish = true
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			convertSecondsToHMS(seconds) {
				var hours = Math.floor(seconds / 3600);
				var minutes = Math.floor((seconds % 3600) / 60);
				var remainingSeconds = seconds % 60;
				minutes = minutes > 9 ? minutes : '0' + minutes
				remainingSeconds = remainingSeconds > 9 ? remainingSeconds : '0' + remainingSeconds

				var time = "00:00"
				if (hours > 0) {
					hours = hours > 9 ? hours : '0' + hours
					time = hours + ":" + minutes + ":" + remainingSeconds;
				} else {
					time = minutes + ":" + remainingSeconds;
				}

				return time;
			},
			seeVideoClick(item, index, itm, ind, smallItm, smallIndex) {
				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				if (!item.is_subject_list.includes('2') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}

				this.selectChapterIndex = -1
				this.currentVideo = -1
				this.selectChapterIndex = ind

				this.videoList = itm.small_list_class
				this.currentVideo = smallIndex

				this.videoVisible = true

			},
			closeVideo() {
				this.videoVisible = false
			},

			subjectInfoClick(item, index) {
				this.subjectBlurb = item.courseSubject.blurb
				this.subjectVisible = true
			},
			examInfoClick(item, index) {
				this.courseSubject = item.courseSubject
				this.examVisible = true
			},
			teacherInfoClick(item, index) {
				this.teacherInfo = item.teacher_info.content
				this.teacherVisible = true
			},
			// 官方样题
			officialClick(item, index) {
				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}

				this.officialInfo = item.courseSubject.official
				this.officialVisible = true
			},
			// 学习笔记
			addStudyClick(item, index) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}

				if (!item.is_subject_list.includes('3') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}

				if (item.course_resource) {
					this.$api.add_lecturer({
						order_item_id: item.id,
						course_resource_id: item.course_resource.id
					}).then((res) => {
						console.log(res);
						
						window.open(item.note_url, '_blank')
						// window.open(item.course_resource.url, '_blank')
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				} else {
					this.$message({
						message: this.langInfo.no_data_available,
						type: 'warning'
					})
				}
			},
			// 浏览课件
			viewRecord(item, index, itm, ind, smallItm, smallIndex) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}

				if (!item.is_subject_list.includes('3') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}
				if (smallItm.courseware_info) {
					this.$api.addCoursewareViewRecord({
						order_item_id: item.id,
						course_chapter_small_id: smallItm.id,
						course_resource_id: smallItm.courseware_info.id
					}).then((res) => {
						console.log(res);
						window.open(smallItm.courseware_info.url, '_blank')
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				} else {
					this.$message({
						message: this.langInfo.no_data_available,
						type: 'warning'
					})
				}
			}

		}
	}
</script>

<style scoped>
	/deep/.el-input__inner::placeholder {
		color: #888888;
	}

	/deep/.el-input__inner {
		height: 100%;
		border-color: #BBBBBB;
	}

	/deep/.el-collapse {
		border: 0px;
		padding: 0 24px;
		box-sizing: border-box;
	}

	/deep/.el-collapse-item__content {
		padding-bottom: 0;
	}

	/deep/.el-collapse-item__header {
		background: #F7F9FC !important;
		height: 64px;
		line-height: 64px;
		color: rgba(0, 0, 0, 1);
		font-size: 16px;
		border: 0px;
	}

	/deep/.el-collapse-item__wrap {
		border: 0px;
		background: #F7F9FC !important;
	}

	.section::after {
		content: '';
		position: absolute;
		width: calc(100% - 22px);
		height: 1px;
		background-color: rgba(216, 216, 216, 0.3);
		bottom: 0;
		right: 0;
	}

	.section:nth-last-child(1)::after {
		content: '';
		position: absolute;
		width: calc(100% - 22px);
		height: 0px;
		background-color: rgba(216, 216, 216, 0.3);
		bottom: 0;
		right: 0;
	}
</style>